import { render, staticRenderFns } from "./TheShop.vue?vue&type=template&id=098c8628&scoped=true"
import script from "./TheShop.vue?vue&type=script&lang=js"
export * from "./TheShop.vue?vue&type=script&lang=js"
import style0 from "./TheShop.vue?vue&type=style&index=0&id=098c8628&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098c8628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('098c8628')) {
      api.createRecord('098c8628', component.options)
    } else {
      api.reload('098c8628', component.options)
    }
    module.hot.accept("./TheShop.vue?vue&type=template&id=098c8628&scoped=true", function () {
      api.rerender('098c8628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/TheShop.vue"
export default component.exports